import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";

import CustomTextInput from '../../components/CustomTextInput';
import CustomButton from '../../components/CustomButton';
import CustomToast from '../../components/CustomToast';
import LoadingOverlay from '../../components/LoadingOverlay';
import CustomBoardNewLogin from '../../components/CustomBoardNewLogin';

import * as selector from '../../../common/selectors';
import * as registrationAction from '../../../common/actions/registration';

import AuthManager from '../../../utils/AuthManager';
import Color from "../../../utils/Color";
import CustomText, { getFontSize, getFontWeight } from '../../components/CustomText';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // Must import the CSS
import CustomModal from '../../components/CustomModal';
import { Grid } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

// Simple regex
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

const useStyles = makeStyles((theme) => ({
  // ... (your styles remain unchanged)
  container: {
    paddingTop: "2rem",
    paddingLeft: '2.7rem',
    paddingRight: '2.7rem',
    [theme.breakpoints.down('sm')]: {
      paddingTop: "0rem",
      paddingLeft: '0rem',
      paddingRight: '0rem',
    },
  },
  headerText: {
    color: '#000000',
    fontSize: 20,
    fontWeight: 700,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    },
  },
  labelTextInputTextStyle: {
    fontWeight: 500,
    fontSize: 16,
    color: '#171717',
    [theme.breakpoints.down('sm')]: {
      fontSize: 15,
    },
  },
  labelTextInputTextStyleError: {
    fontWeight: 500,
    fontSize: 16,
    color: '#EF4444',
  },
  labelTextInputTextStyleSuccess: {
    fontWeight: 500,
    fontSize: 16,
    color: '#10B981',
  },
  textInputContainer: {
    height: 48,
    marginBottom: 25,
    marginTop: 5,
  },
  textInputContainerError: {
    height: 48,
    marginBottom: 0,
    marginTop: 5,
    border: '1px solid #EF4444',
  },
  textInputContainerStrongPassw: {
    height: 48,
    marginBottom: 0,
    marginTop: 5,
    border: '1px solid #10B981',
  },
  textInputContainerDis: {
    height: 48,
    marginBottom: 25,
    marginTop: 5,
    backgroundColor: "#F2F2F2",
    color: '#B1B1B1',
  },
  errorTextStyle: {
    marginTop: 0,
    marginBottom: 15,
  },
  successTextStyle: {
    marginTop: 0,
    marginBottom: 15,
    color: '#10B981',
  },
  inputContentContainer: {
    marginTop: '1.5rem',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  buttonStyle: {
    height: '48px',
    [theme.breakpoints.down('sm')]: {
      height: '44px',
    },
  },
  modalDesign: {
    padding: 0,
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 5,
    textAlign: 'center',
    [theme.breakpoints.down("xs")]: {
      minWidth: 200,
      marginTop: 20,
      marginBottom: 20,
    },
    [theme.breakpoints.up("sm")]: {
      minWidth: 200,
    },
    [theme.breakpoints.up("lg")]: {
      minWidth: 250,
      maxWidth: 250,
    },
    textInputStyle: {
      height: 35,
      marginLeft: 5,
      marginRight: 5,
    },
    containerStyle: {
      flexGrow: 1,
      marginBottom: 30,
      paddingRight: 20,
      marginBottom: 30
    },
    tooltipContainer: {
      display: "flex",
      alignItems: "center",
    },
    titleTextStyle: {
      fontWeight: 'bold',
      fontSize: 25,
    },
  },
  helpText: {
    marginTop: '3.5rem',
    fontSize: '12px',
    color: '#818181',
    textAlign: 'center',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2rem',
      fontSize: '11px',
    },
  },
}));

const NormalReg = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  // --------------------------
  // Local States
  // --------------------------
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneCountryCode, setPhoneCountryCode] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [dob, setDob] = useState('');
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');
  const [registrationFormTypeId, setRegistrationFormTypeId] = useState(null);

  // Validation states (existing validations)
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [isRetypePasswordMatch, setIsRetypePasswordMatch] = useState(true);
  const [isDOBValid, setIsDOBValid] = useState(true);
  const [dobValue, setDobValue] = useState('');
  const [isPhoneValid, setIsPhoneValid] = useState(true);

  // Touched states for some fields (existing ones)
  const [emailTouched, setEmailTouched] = useState(false);
  const [passwordTouched, setPasswordTouched] = useState(false);
  const [retypeTouched, setRetypeTouched] = useState(false);
  const [dobTouched, setDobTouched] = useState(false);
  const [phoneTouched, setPhoneTouched] = useState(false);
  const [nameTouched, setNameTouched] = useState(false);
  const [nameValid, setNameValid] = useState(true);
  const [idTouched, setIdTouched] = useState(false);
  const [idValid, setIdValid] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  // New state: an object to track errors for each field
  const [formErrors, setFormErrors] = useState({
    name: false,
    email: false,
    phone: false,
    dob: false,
    userId: false,
    password: false,
    retypePassword: false,
  });

  // Redux states and others
  const [regAction, setRegAction] = useState(false);
  const [customToastStatus, setCustomToastStatus] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [isFromLocalSto, setIsFromLocalSto] = useState(false);
  const [countdown, setCountdown] = useState(300); // 5 minutes
  const [backToHome, setBackToHome] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const [showRetypePassword, setShowRetypePassword] = useState(false);
  const registerNewCustomerData = useSelector(selector.registerNewCustomerData);
  const registerNewCustomerLoading = useSelector(selector.registerNewCustomerLoading);
  const registerNewCustomerStatus = useSelector(selector.registerNewCustomerStatus);
  const [isLoading, setIsLoading] = useState(false); // New state for loading
  // Redux selectors for getRegistrationCustomerDetails
  const customerDetails = useSelector(selector.getRegistrationCustomerDetailsData);
  const customerDetailsLoading = useSelector(selector.getRegistrationCustomerDetailsLoading);
  const customerDetailsStatus = useSelector(selector.getRegistrationCustomerDetailsStatus);
  const [successCalled, setSuccessCalled] = useState(false);
  // --------------------------
  // Countdown Timer
  // --------------------------
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prevTime => {
        if (prevTime <= 1) {
          clearInterval(timer);
          history.push("/"); // Redirect to home when time is up
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [history]);

  // --------------------------
  // Retrieve localStorage on mount
  // --------------------------
  useEffect(() => {
    const init = async () => {
      const countryCode = await AuthManager.retrieveMobileCountryCode();
      if (countryCode) {
        setPhoneCountryCode(countryCode);
        setIsFromLocalSto(true);
      }
    };
    init();
  }, []);

  // useEffect(() => {
  //   const storedData = localStorage.getItem('newRegCusDetail');
  //   if (storedData) {
  //     try {
  //       const parsed = JSON.parse(storedData);
  //       setName(parsed?.Name || '');
  //       setEmail(parsed?.Email || '');
  //       setPhoneNumber(parsed?.Mobile || '');
  //       setDobValue(parsed?.Dob || '');
  //       setRegistrationFormTypeId(parsed?.RegistrationFormTypeId || null);
  //     } catch (error) {
  //       console.warn('Failed to parse localStorage data:', error);
  //     }
  //   }
  // }, []);

  useEffect(() => {
    const otpCode = localStorage.getItem('otpCode');
    const otpRef = localStorage.getItem('OtpRef');

    setIsLoading(true); // Start loading
    const data = {
      AuthCode: "",
      AuthState: "",
      Otp: otpCode,
      OtpReference: otpRef,
      InApp: localStorage.getItem('inapp') === "1" ? "1" : ""
    };
    dispatch(registrationAction.getRegistrationCustomerDetails(data));

  }, [dispatch]);

  useEffect(() => {
    if (!customerDetailsLoading) {
      setIsLoading(false); // Stop loading once response is received
      if (customerDetails?.Data) {
        const regData = customerDetails.Data;
        const regSuccess = customerDetails?.Success;
        if (regSuccess) {
          setSuccessCalled(true);
          setName(regData?.Name || '');
          setEmail(regData?.Email || '');
          setPhoneNumber(regData?.Mobile || '');
          setDobValue(regData?.Dob || '');
          setRegistrationFormTypeId(regData?.RegistrationFormTypeId || null);
        } else {
          setDisabledBtn(true);
          setSuccessCalled(false);
          setIsVisible(true)
        }
      } else if (customerDetails?.Data === null) {
        setDisabledBtn(true);
        setSuccessCalled(false);
        setIsVisible(true)
      }
    }
  }, [customerDetails, customerDetailsLoading, customerDetailsStatus]);

  // --------------------------
  // Handle Redux Response
  // --------------------------
  useEffect(() => {
    if (regAction && !registerNewCustomerLoading) {
      if (registerNewCustomerStatus && registerNewCustomerData) {
        const regData = registerNewCustomerData.Data?.LoginResponseModel;
        const regSuccess = registerNewCustomerData.Success;
        const inAppIsCompleted = registerNewCustomerData.Data?.IsCompleted;
        //InApp Flow
        const inappValue = localStorage.getItem('inapp'); // '1' if set, or null if not
        if (regSuccess && inAppIsCompleted && inappValue === "1") {

          localStorage.removeItem("inapp");
          window.location.href = process.env.REACT_APP_INAPP_DEEPLINK + `?code=${localStorage.getItem('otpCode') || ''}&state=${localStorage.getItem('OtpRef') || ''}`;
          return;

        } else if (regSuccess && regData?.AccessToken) {
          localStorage.removeItem("otpCode")
          localStorage.removeItem("OtpRef")
          localStorage.removeItem("MobileCountryCode")
          localStorage.removeItem("newRegCusDetail")
          localStorage.removeItem("ClientMobileNo")
          localStorage.removeItem("NRIC")
          AuthManager.setIsMasterAccount(regData?.IsMasterAccount);
          AuthManager.setToken(regData?.AccessToken);
          AuthManager.setSessionID(regData?.SessionId);
          AuthManager.setExpiryWarning(regData?.SessionExpiryWarning);
          AuthManager.setExpiryEnd(regData?.SessionExpiryEnd);
          AuthManager.setDirectClient(regData?.DirectClient);
          AuthManager.removeMobileCountryCode();
          setIsFromLocalSto(false);
          window.location.href = process.env.REACT_APP_TIQ_BASE_URL;
        } else {
          setCustomToastStatus(true);
          //setBackToHome(true)
          setToastMessage(registerNewCustomerData.Data?.ErrorMessage || 'Registration failed.');
        }
      } else if (!registerNewCustomerStatus && registerNewCustomerData === null) {
        setCustomToastStatus(true);
        //setBackToHome(true)
        setToastMessage("Something went wrong, Please retry later.");
      }
      setRegAction(false);
    }
  }, [
    regAction,
    registerNewCustomerData,
    registerNewCustomerLoading,
    registerNewCustomerStatus
  ]);

  // --------------------------
  // Determine disabled fields
  // --------------------------
  const regData = customerDetails?.Data;
  const isDobDisabled = (registrationFormTypeId === 1 || registrationFormTypeId === 3) && (regData?.Dob !== '');
  const isMobileDisabled = (registrationFormTypeId === 3 || registrationFormTypeId === 4 || disabledBtn);
  const isNameDisabled = (registrationFormTypeId === 1 || registrationFormTypeId === 3) && (regData?.Name !== '');

  // --------------------------
  // Validation Handlers (existing ones)
  // --------------------------
  const handleEmailChange = (val) => {
    setEmail(val);
    if (!emailTouched && val.length > 0) {
      setEmailTouched(true);
    }
    if (val.length > 0) {
      setIsEmailValid(emailRegex.test(val.trim()));
    } else {
      setIsEmailValid(false);
    }
  };

  const handleNameChange = (val) => {
    setName(val);
    if (!nameTouched && val.length > 0) {
      setNameTouched(true);
    }
    if (val.length > 0) {
      setNameValid(true);
    } else {
      setNameValid(false);
    }
  };

  const handleChooseIdChange = (val) => {
    setUserId(val);
    if (!idTouched && val.length > 0) {
      setIdTouched(true);
    }

    // Validation logic based on UserID requirements
    if (val.length > 0) {
      const minLengthValid = val.length >= 8;
      const allowedCharsValid = /^[A-Za-z0-9@_.-]+$/.test(val); // Allow letters, numbers, @, _, -, and .
      // Simple NRIC check: assuming NRIC is 9 chars starting with S/T/F/G followed by 7 digits and a letter
      const isNotNRIC = !/^[STFG]\d{7}[A-Z]$/i.test(val);

      // Set idValid true only if all conditions are met
      setIdValid(minLengthValid && allowedCharsValid && isNotNRIC);
    } else {
      setIdValid(false);
    }
  };

  const handlePasswordChange = (val) => {
    setPassword(val);
    if (!passwordTouched && val.length > 0) {
      setPasswordTouched(true);
    }
    if (val.length > 0) {
      setIsPasswordValid(passwordRegex.test(val));
    } else {
      setIsPasswordValid(false);
      setPasswordTouched(true);
    }
    setIsRetypePasswordMatch(val === retypePassword);
  };

  const handleRetypePasswordChange = (val) => {
    setRetypePassword(val);
    if (!retypeTouched && val.length > 0) {
      setRetypeTouched(true);
    }
    setIsRetypePasswordMatch(password === val);
  };

  // --------------------------
  // Field Validation on Activate
  // --------------------------
  const validateFields = () => {
    return {
      name: !name,
      email: !email || !isEmailValid,
      phone: !phoneNumber || !isPhoneValid,
      dob: !dobValue || !isDOBValid,
      userId: !userId || !idValid,
      password: !password || !isPasswordValid,
      retypePassword: !retypePassword || !isRetypePasswordMatch,
    };
  };

  const onClickActivate = () => {
    const errorsFound = validateFields();
    setFormErrors(errorsFound);
    // If any error exists, do not proceed
    if (Object.values(errorsFound).some(val => val)) {
      setCustomToastStatus(true);
      setToastMessage("Please fill in all required fields correctly.");
      return;
    }

    const data = {
      FullName: name,
      AuthCode: localStorage.getItem('otpCode') || '',
      AuthState: localStorage.getItem('OtpRef') || '',
      // Otp: localStorage.getItem('otpCode') || '',
      // OtpReference: localStorage.getItem('OtpRef') || '',
      Email: email,
      Mobile: phoneNumber,
      MobileCountryCode: (phoneCountryCode === "65" || phoneCountryCode === "+65") ? "" : phoneCountryCode,
      Password: password,
      ConfirmPassword: retypePassword,
      UserId: userId,
      Dob: dobValue,
      RegistrationFormTypeId: registrationFormTypeId
    };

    dispatch(registrationAction.registerNewCustomer(data));
    setRegAction(true);
  };

  // --------------------------
  // Toast Close Handler
  // --------------------------
  const handleCloseCustomToast = (event, reason) => {
    if (reason === 'clickaway') return;
    setCustomToastStatus(false);
  };

  // --------------------------
  // Handle DOB Change (existing)
  // --------------------------
  const handleDOBChange = (raw) => {
    let digits = raw.replace(/\D/g, '').slice(0, 8);
    let display = digits;
    if (digits.length >= 5) {
      display = digits.slice(0, 2) + '/' + digits.slice(2, 4) + '/' + digits.slice(4);
    } else if (digits.length >= 3) {
      display = digits.slice(0, 2) + '/' + digits.slice(2);
    }
    setDobTouched(true);
    setDobValue(display);
    if (digits.length === 8) {
      const dd = parseInt(digits.slice(0, 2), 10);
      const mm = parseInt(digits.slice(2, 4), 10);
      const yyyy = parseInt(digits.slice(4, 8), 10);
      const dt = new Date(yyyy, mm - 1, dd);
      const validDate = (
        dt.getFullYear() === yyyy &&
        dt.getMonth() === (mm - 1) &&
        dt.getDate() === dd
      );
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const notFuture = dt.getTime() <= today.getTime();
      setIsDOBValid(validDate && notFuture);
    } else {
      setIsDOBValid(false);
    }
  };

  // --------------------------
  // Handle Phone Change (existing)
  // --------------------------
  const handlePhoneChange = (value, countryData) => {
    // Example: "6591234567" when countryData.dialCode is "65"
    setPhoneCountryCode(countryData.dialCode);
    setPhoneNumber(value);
    if (!phoneTouched && value.length > 0) {
      setPhoneTouched(true);
    }
    if (value !== phoneCountryCode) {
      setIsPhoneValid(true);
    } else {
      setIsPhoneValid(false);
    }
  };

  // Toggle password visibility
  const handleClickShowPassword = () => {
    setShowPassword(prev => !prev);
  };

  const handleClickShowRetypePassword = () => {
    setShowRetypePassword(prev => !prev);
  };

  // Prevent default mouse down behavior (optional, for better UX)
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // --------------------------
  // Render Page
  // --------------------------
  const renderPage = () => {
    // Determine styling for email, password, etc. (you can also use formErrors here) 

    // const passwordTextStyle = (formErrors.password || (!isPasswordValid && passwordTouched && password.length > 0)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
    // const passwordDesign = (formErrors.password || (!isPasswordValid && passwordTouched && password.length > 0)) ? classes.textInputContainerError : classes.textInputContainerStrongPassw;

    const chooseIdTextStyle = (formErrors.userId || (idTouched && !idValid)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
    const chooseIdDesign = (formErrors.userId || (idTouched && !idValid)) ? classes.textInputContainerError : classes.textInputContainer;

    const nameTextStyle = (formErrors.name || nameTouched && !nameValid) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
    const nameDesign = (formErrors.name || nameTouched && !nameValid) ? classes.textInputContainerError : classes.textInputContainer;

    const emailTextStyle = (formErrors.email || (emailTouched && !isEmailValid)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
    const emailDesign = (formErrors.email || (emailTouched && !isEmailValid)) ? classes.textInputContainerError : classes.textInputContainer;

    const passwordTextStyle = (passwordTouched && isPasswordValid) ? classes.labelTextInputTextStyleSuccess
      : ((passwordTouched || formErrors.password) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle);
    const passwordDesign = (passwordTouched && isPasswordValid) ? classes.textInputContainerStrongPassw : ((passwordTouched || formErrors.password) ? classes.textInputContainerError : classes.textInputContainer);

    const retypeTextStyle = (formErrors.retypePassword || (retypeTouched && !isRetypePasswordMatch)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
    const retypeDesign = (formErrors.retypePassword || (retypeTouched && !isRetypePasswordMatch)) ? classes.textInputContainerError : classes.textInputContainer;

    const dobTextStyle = (formErrors.dob || (dobTouched && !isDOBValid)) ? classes.labelTextInputTextStyleError : classes.labelTextInputTextStyle;
    const dobDesign = (formErrors.dob || (dobTouched && !isDOBValid)) ? classes.textInputContainerError : classes.textInputContainer;
    // Compute if the form has any errors 
    const errors = validateFields();
    const isFormInvalid = Object.values(errors).some(val => val);
    return (
      <div className={classes.container}>
        {/* Header Text */}
        <div className={classes.headerText}>
          Register and Activate your Account
        </div>

        {/* Optional: Display the countdown */}
        {/* <div style={{ textAlign: "center", marginBottom: "1rem", fontWeight: "bold", color: "red" }}>
          Time remaining: {Math.floor(countdown / 60)}:{("0" + (countdown % 60)).slice(-2)}
        </div> */}

        <div className={classes.inputContentContainer}>
          {/* Name */}
          <CustomTextInput
            title="Name"
            textstyle={nameTextStyle}
            design={(disabledBtn || isNameDisabled) ? classes.textInputContainerDis : nameDesign}
            // textstyle={emailTextStyle}
            // design={emailDesign}
            fullWidth
            value={name}
            onChange={(e) => {
              //setName(e.target.value);
              handleNameChange(e.target.value)
              setFormErrors(prev => ({ ...prev, name: false }));
            }}
            error={formErrors.name || nameTouched && !nameValid}
            errorMessage="Please enter your name."
            errorTextStyle={classes.errorTextStyle}
            disabled={disabledBtn || isNameDisabled}
          />

          {/* Email */}
          <CustomTextInput
            title="Email"
            textstyle={emailTextStyle}
            design={disabledBtn ? classes.textInputContainerDis : emailDesign}
            fullWidth
            value={email}
            onChange={(e) => {
              handleEmailChange(e.target.value);
              setFormErrors(prev => ({ ...prev, email: false }));
            }}
            error={formErrors.email || emailTouched && !isEmailValid}
            errorMessage={!email ? "Please enter your email." : "Please enter a valid email."}
            errorTextStyle={classes.errorTextStyle}
            disabled={disabledBtn}
          />

          {/* Mobile */}
          <div style={{ width: '100%' }}>
            <div className={classes.labelTextInputTextStyle} style={{ marginBottom: 5, fontWeight: 400 }}>
              Mobile Number
            </div>
            {isMobileDisabled ? (
              <CustomTextInput
                value={phoneNumber}
                design={classes.textInputContainerDis}
                disabled
                fullWidth
              />
            ) : (
              <div style={{ marginBottom: 25 }}>
                <PhoneInput
                  country={'sg'}
                  value={phoneNumber}
                  onChange={(val, countryData) => {
                    handlePhoneChange(val, countryData);
                    setFormErrors(prev => ({ ...prev, phone: false }));
                  }}
                  inputStyle={{
                    width: '100%',
                    height: '48px',
                  }}
                  enableSearch
                  countryCodeEditable={false}
                />
                {(formErrors.phone || (!isPhoneValid && phoneTouched)) && (
                  <div style={{ color: "#EF4444", fontSize: 12, marginTop: 5 }}>
                    Please enter your mobile number.
                  </div>
                )}
              </div>
            )}
          </div>

          {/* DOB */}
          <CustomTextInput
            title="Date of Birth"
            textstyle={dobTextStyle}
            design={(disabledBtn || isDobDisabled) ? classes.textInputContainerDis : dobDesign}
            fullWidth
            value={dobValue}
            onChange={(e) => {
              handleDOBChange(e.target.value);
              setFormErrors(prev => ({ ...prev, dob: false }));
            }}
            error={formErrors.dob || (dobTouched && !isDOBValid)}
            errorTextStyle={classes.errorTextStyle}
            errorMessage={!dobValue ? "Please enter your date of birth." : "Invalid date or future date. Use DD/MM/YYYY."}
            placeholder={"DD/MM/YYYY"}
            disabled={disabledBtn || isDobDisabled}
          />

          {/* UserID */}
          <CustomTextInput
            title="Choose UserID"
            textstyle={chooseIdTextStyle}
            design={disabledBtn ? classes.textInputContainerDis : chooseIdDesign}
            //textstyle={emailTextStyle}
            //design={emailDesign}
            fullWidth
            value={userId}
            onChange={(e) => {
              handleChooseIdChange(e.target.value);
              setFormErrors(prev => ({ ...prev, userId: false }));
            }}
            error={formErrors.userId || (idTouched && !idValid)}
            errorMessage="Please choose a UserID."
            errorTextStyle={classes.errorTextStyle}
            toolTip={true}
            // toolTipText={`Username requirements:`}
            //toolTipText2={`tetsdomk`}
            toolTipTexts={["Username requirements:", "• Minimum 8 characters", "• Only letters, numbers and '@' / '_' /  '-'  can be used", "• Username cannot be NRIC"]}
            disabled={disabledBtn}
         />

          {idTouched && <div style={{ marginBottom: 30, marginTop: -10 }}>
            <CustomText style={{ marginTop: 0, fontWeight: 'bold' }}>
              Username requirements:
            </CustomText>
            <div style={{ marginLeft: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {userId.length >= 8 ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>Minimum 8 characters</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/^[A-Za-z0-9@_-]+$/.test(userId) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>
                  Only letters, numbers and '@' / '_' / '-' can be used
                </CustomText>
              </div>
            </div>
          </div>}

          {/* Password */}
          <CustomTextInput
            title="Choose Password"
            // textstyle={passwordTextStyle}
            // design={passwordDesign}
            textstyle={passwordTextStyle}
            design={passwordDesign}
            fullWidth
            type={showPassword ? 'text' : 'password'} // Toggle type based on state
            value={password}
            onChange={(e) => {
              handlePasswordChange(e.target.value);
              setFormErrors(prev => ({ ...prev, password: false }));
            }}
            error={formErrors.password || (!isPasswordValid && passwordTouched)}
            errorMessage={!password ? "Please enter a password." : "Weak Password"}
            errorTextStyle={classes.errorTextStyle}
            success={isPasswordValid && passwordTouched && password.length > 0}
            successMessage={'Strong Password'}
            successTextStyle={classes.successTextStyle}
            toolTip={true}
            toolTipTexts={["Password requirements:", "• Minimum 8 Characters", "• At least 1 uppercase", "• At least 1 lowercase", "• At least 1 number", "• At least 1 special character"]}
            endAdornment={(
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>

            )}
            disabled={disabledBtn}
          />

          {passwordTouched && <div style={{ marginBottom: 30, marginTop: -10 }}>
            <CustomText style={{ fontWeight: 'bold', marginBottom: 8 }}>
              Password requirements:
            </CustomText>
            <div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {password.length >= 8 ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>Minimum 8 Characters</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/[A-Z]/.test(password) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>At least 1 uppercase</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/[a-z]/.test(password) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>At least 1 lowercase</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/\d/.test(password) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>At least 1 number</CustomText>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: 4 }}>
                {/[^A-Za-z0-9]/.test(password) ? (
                  <CheckCircleIcon style={{ color: 'green', fontSize: 16, marginRight: 4 }} />
                ) : (
                  <CancelIcon style={{ color: 'red', fontSize: 16, marginRight: 4 }} />
                )}
                <CustomText>At least 1 special character</CustomText>
              </div>
            </div>
          </div>}

          {/* Re-type Password */}
          <CustomTextInput
            title="Re-type Password"
            textstyle={retypeTextStyle}
            design={disabledBtn ? classes.textInputContainerDis : retypeDesign}
            fullWidth
            type={showRetypePassword ? 'text' : 'password'} // Toggle type based on state
            value={retypePassword}
            onChange={(e) => {
              handleRetypePasswordChange(e.target.value);
              setFormErrors(prev => ({ ...prev, retypePassword: false }));
            }}
            error={formErrors.retypePassword || (retypeTouched && !isRetypePasswordMatch)}
            errorMessage={!retypePassword ? "Please re-type your password." : "Passwords do not match."}
            errorTextStyle={classes.errorTextStyle}
            disabled={disabledBtn}
            endAdornment={(
              <IconButton
                aria-label="toggle retype password visibility"
                onClick={handleClickShowRetypePassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showRetypePassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            )}
          />
        </div>

        {/* Activate Button */}
        <div style={{ width: '100%', marginTop: '1rem' }}>
          <CustomButton
            title="Activate"
            design={classes.buttonStyle}
            onClick={onClickActivate}
            disabled={isFormInvalid || registerNewCustomerLoading || disabledBtn || isLoading} // Disable if form is invalid or loading />
          />
        </div>

        <div className={classes.helpText}>
          If you encounter any issues, please contact our Customer Service Centre
          via our hotline +65 6887 8777 or WhatsApp us at +65 6887 8777
        </div>
      </div>
    );
  };

  const renderMaintenanceChild = () => <></>;
  const height = 800;
  const width = 600;

  const modalContainer = () => {
    return (
      <div className={classes.containerStyle}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.tooltipContainer}>
              <CustomText design={classes.titleTextStyle} style={{ marginBottom: 10 }}>
                {customerDetails?.Data?.Message || "Something went wrong, Please retry later."}
              </CustomText>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  };

  const onClickNextButton = () => {
    history.push("/")

  };


  return (
    <>
      <CustomBoardNewLogin
        maintenanceChild={renderMaintenanceChild()}
        children={renderPage()}
        height={height}
        width={width}
      />
      <CustomToast
        open={customToastStatus}
        handleCloseCustomToast={handleCloseCustomToast}
        title={toastMessage}
        backToHome={backToHome}
        warning
      />

      {/* <CustomModal
        open={isVisible}
        //handleClose={handleClose}
        //titlestyle={classes.modalTitleStyle}
        modalDesign={classes.modalDesign}
        submitButtonText={"OK"}
        //cancelButtonText={"Cancel"}
        modalComponent={modalContainer()}
        disableBackdropClick
        handleSubmitButton={() => onClickNextButton()}
        isVisibleCloseButton={false}
        okBtnSty={true}
      // handleCancelButton={handleClose}
      /> */}
      {registerNewCustomerLoading || isLoading && <LoadingOverlay loading={true} />}
    </>
  );
};

export default NormalReg;
